/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './integration-template-category.reducer';

export const IntegrationTemplateCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const integrationTemplateCategoryEntity = useAppSelector(state => state.integrationTemplateCategory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="integrationTemplateCategoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.detail.title">IntegrationTemplateCategory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateCategoryEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateCategoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateCategoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateCategoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateCategoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateCategoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.template">Template</Translate>
          </dt>
          <dd>{integrationTemplateCategoryEntity.template ? integrationTemplateCategoryEntity.template.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.category">Category</Translate>
          </dt>
          <dd>{integrationTemplateCategoryEntity.category ? integrationTemplateCategoryEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationTemplateCategory.channel">Channel</Translate>
          </dt>
          <dd>{integrationTemplateCategoryEntity.channel ? integrationTemplateCategoryEntity.channel.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/integration-template-category" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/integration-template-category/${integrationTemplateCategoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntegrationTemplateCategoryDetail;
